import PropTypes from 'prop-types';

import ExternalLinkIcon from '@mui/icons-material/OpenInNew';
import { useMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';

function EnterpriseLink({ label, ...delegated }) {
  const linkLabel = useMessage('dashboard.component.enterpriseLink.label', {
    enterpriseName: label,
  });

  return (
    <Button
      clickstreamProps={{ elementName: 'enterprise_link' }}
      icon={<ExternalLinkIcon fontSize="small" />}
      target="_blank"
      variant="outlined"
      {...delegated}
    >
      {linkLabel}
    </Button>
  );
}

EnterpriseLink.propTypes = {
  label: PropTypes.string,
  href: PropTypes.string.isRequired,
};

export default EnterpriseLink;
